import { ExternalLink, Video as VideoIcon } from "lucide-react";

function driveEmbed(url) {
  const m = url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/) || url.match(/[?&]id=([a-zA-Z0-9_-]+)/);
  if (m) return `https://drive.google.com/file/d/${m[1]}/preview`;
  return null;
}

export default function VideoPlayer({ url }) {
  if (!url) {
    return (
      <div className="rounded-2xl border border-[#1E293B] bg-[#090D16] p-10 text-center text-slate-600 text-sm flex flex-col items-center gap-2">
        <VideoIcon className="w-6 h-6" /> No recording linked for this lesson.
      </div>
    );
  }
  const isDrive = /drive\.google\.com/.test(url);
  const embed = isDrive ? driveEmbed(url) : null;
  const resolved = url.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
  const isNative = /\.(mp4|webm|ogg|mov)(\?|$)/i.test(url) || url.startsWith("/api/files/");

  return (
    <div className="space-y-2" data-testid="video-player">
      <div className="relative rounded-2xl overflow-hidden border border-[#1E293B] bg-black aspect-video">
        {embed ? (
          <iframe src={embed} title="Lesson recording" allow="autoplay; encrypted-media" allowFullScreen className="w-full h-full" />
        ) : isNative ? (
          <video src={resolved} controls className="w-full h-full" />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center text-slate-500 gap-2 text-sm">
            <VideoIcon className="w-7 h-7" />
            <span>Preview not available for this link.</span>
          </div>
        )}
      </div>
      <a href={resolved} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-xs text-emerald-400 hover:underline" data-testid="open-video-link">
        <ExternalLink className="w-3.5 h-3.5" /> Open recording in a new tab
      </a>
    </div>
  );
}
